import MedicalRecord from "../components/medicalRecordComponent";
import MedicalRecordReport from "../components/medicalRecordReportComponent";
import MedicalRecordDetailReport from "../components/medicalRecordDetailReportComponent";

export const MedicalRecordRoute = [
  {
    path: "medical-record",
    component: MedicalRecord,
  },
  {
    path: "medical-record/report",
    component: MedicalRecordReport,
  },
  {
    path: "medical-record/report/:id",
    component: MedicalRecordDetailReport,
  },
];
